import { useAppSelector } from '@/store/hooks/useAppSelector';
// import { Page404 } from '@/pages/Page404';
import useAuth from './hooks/useAuth';
import { getSelectedAgent, getSelectedAgentId } from '@/store/account/selector';
import { Navigate, Outlet } from 'react-router-dom';
import { AppRoutes } from 'src/enums/ERoutes';
import { Loading } from '@/components/Loading';

export const InboundAgentRoute = () => {
	const { isAuthenticated, isLoading } = useAuth();
	const selectedAgent = useAppSelector(getSelectedAgent);
	const selectedAgentId = useAppSelector(getSelectedAgentId);

	if (isLoading) {
		return <Loading />;
	}

	if (!isAuthenticated) {
		return <Navigate to={AppRoutes.RECEPTIONIST_LOGIN} replace />;
	} else if (!selectedAgent || !selectedAgentId) {
		return <Navigate to={AppRoutes.DASHBOARD} />;
	}

	// If all checks pass, render the route
	return <Outlet />;
};

export default InboundAgentRoute;
